/* ==========================================================================
   lpf-bf.js — Phasensteuerung der Black-Friday-Landingpages 2026 (lp-bf-*).
   Ergänzt lpf.js (Formular, Videos, Tracking), ändert nichts daran.

   - Phase: der Server rendert die gültige Phase (Metaobjekte + Datum). Das Skript
     korrigiert nur nach vorne (Seite aus dem Cache über eine Phasengrenze) und
     schaltet eine offen gelassene Seite an der Grenze selbst um.
   - Vorschau: ?bf_vorschau=ea|bw|we|ende zeigt jede Phase sofort.
   - Countdown bis Phasenende, Tage bis Phasenende, Hero-Bild je Phase,
     Codes kopieren, Vorher/nachher-Regler.
   ========================================================================== */
(function () {
  'use strict';
  if (window.LPFBF && window.LPFBF.__ready) return;
  var BF = window.LPFBF = window.LPFBF || {};
  BF.__ready = true;

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function track(evt, p) { try { if (window.LPF && window.LPF.track) window.LPF.track(evt, p || {}); } catch (e) {} }

  var cfg = null, cur = null, preview = '';
  function readCfg() {
    var el = document.querySelector('[data-bf-t]');
    if (!el) return null;
    var t = (el.getAttribute('data-bf-t') || '').split(',').map(function (x) { return parseInt(x, 10) || 0; });
    var ok = (el.getAttribute('data-bf-ok') || '').split(',').map(function (x) { return x === 'true'; });
    return { t: t, ok: ok, rank: parseInt(el.getAttribute('data-bf-rank') || '0', 10) || 0 };
  }
  function rankAt(ms) { var s = ms / 1000; if (s < cfg.t[1]) return 0; if (s < cfg.t[2]) return 1; if (s <= cfg.t[3]) return 2; return 3; }
  function phaseOf(rank) { return rank === 0 ? 'ea' : rank === 1 ? (cfg.ok[0] ? 'bw' : 'ende') : rank === 2 ? (cfg.ok[1] ? 'we' : 'ende') : 'ende'; }
  function endOf(ph) { return ph === 'ea' ? cfg.t[1] - 1 : ph === 'bw' ? cfg.t[2] - 1 : ph === 'we' ? cfg.t[3] : 0; }
  function currentPhase() {
    if (preview) return preview;
    return phaseOf(Math.max(cfg.rank, rankAt(Date.now())));
  }

  function swapImages(ph) {
    var grp = ph === 'ea' ? 'ea' : 'sale';
    $$('[data-bf-srcset-' + grp + ']').forEach(function (el) {
      var ss = el.getAttribute('data-bf-srcset-' + grp), src = el.getAttribute('data-bf-src-' + grp);
      if (ss && el.getAttribute('srcset') !== ss) el.setAttribute('srcset', ss);
      if (src && el.getAttribute('src') !== src) el.setAttribute('src', src);
    });
  }

  function apply(ph) {
    if (ph === cur) return;
    cur = ph;
    document.documentElement.setAttribute('data-bf-phase', ph);
    $$('[data-bf-ph]').forEach(function (el) {
      var on = (' ' + el.getAttribute('data-bf-ph') + ' ').indexOf(' ' + ph + ' ') !== -1;
      if (el.hidden === on) el.hidden = !on;
    });
    $$('[data-bf-track]').forEach(function (ol) {
      var order = ['ea', 'bw', 'we'], idx = order.indexOf(ph);
      $$('li[data-bf-step]', ol).forEach(function (li) {
        var k = order.indexOf(li.getAttribute('data-bf-step'));
        li.classList.toggle('is-now', k === idx);
        li.classList.toggle('is-past', idx === -1 ? true : k < idx);
      });
    });
    swapImages(ph);
    var end = endOf(ph);
    $$('[data-bf-cd]').forEach(function (el) { el.setAttribute('data-bf-cd', String(end)); });
    tick();
  }

  function tick() {
    var now = Date.now();
    if (!preview) { var p = currentPhase(); if (p !== cur) { apply(p); return; } }
    var end = endOf(cur) * 1000;
    var d = Math.max(0, end - now), s = Math.floor(d / 1000);
    var u = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
    $$('[data-bf-cd]').forEach(function (el) {
      $$('[data-u]', el).forEach(function (n) { var k = n.getAttribute('data-u'); var t = String(k === 'd' ? u.d : pad(u[k])); if (n.textContent !== t) n.textContent = t; });
      var inl = el.querySelector('[data-bf-cd-inline]');
      if (inl) { var it = (u.d > 0 ? u.d + ' T ' : '') + pad(u.h) + ':' + pad(u.m) + ':' + pad(u.s); if (inl.textContent !== it) inl.textContent = it; }
    });
    var days = String(Math.max(0, Math.ceil(d / 86400000)));
    $$('[data-bf-days]').forEach(function (el) { if (el.textContent !== days) el.textContent = days; });
  }

  /* Codes kopieren */
  function copied(btn) {
    btn.classList.add('is-copied');
    var l = btn.querySelector('[data-bf-copy-l]');
    if (l) { if (!l.__o) l.__o = l.textContent; l.textContent = 'Kopiert'; }
    clearTimeout(btn.__t);
    btn.__t = setTimeout(function () { btn.classList.remove('is-copied'); if (l && l.__o) l.textContent = l.__o; }, 2200);
  }
  function fallbackCopy(code) {
    var ta = document.createElement('textarea');
    ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-bf-copy]') : null;
    if (!b) return;
    e.preventDefault();
    var code = b.getAttribute('data-bf-copy');
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(function () { copied(b); }, function () { fallbackCopy(code); copied(b); });
      else { fallbackCopy(code); copied(b); }
    } catch (x) { fallbackCopy(code); copied(b); }
    var pg = document.querySelector('[data-lpf-page]');
    track('bf_code_copy', { code: code, phase: cur, lp_slug: pg ? pg.getAttribute('data-lpf-page') : '', lp_angle: pg ? pg.getAttribute('data-lpf-angle') : '' });
  });

  /* Vorher/nachher */
  function initCompare(root) {
    $$('[data-bf-cmp]', root).forEach(function (box) {
      if (box.__bf) return; box.__bf = 1;
      var r = box.querySelector('input[type="range"]');
      if (!r) return;
      var set = function () { box.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set); set();
      r.addEventListener('change', function () { track('bf_compare', { pos: r.value }); }, { once: true });
    });
  }

  function init() {
    initCompare(document);
    cfg = readCfg();
    if (!cfg) return;
    try { var v = new URLSearchParams(location.search).get('bf_vorschau'); if (/^(ea|bw|we|ende)$/.test(v || '')) preview = v; } catch (e) {}
    cur = null;
    apply(currentPhase());
    if (preview) {
      var n = document.createElement('div');
      n.textContent = 'Vorschau Phase: ' + preview;
      n.setAttribute('style', 'position:fixed;left:12px;top:12px;z-index:2147483001;padding:6px 10px;border-radius:8px;background:#111214;color:#d6bd8e;font:700 12px/1.2 system-ui,sans-serif;letter-spacing:.06em;text-transform:uppercase;pointer-events:none');
      document.body.appendChild(n);
    }
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initCompare(e.target); });
})();
